import InputLabel from "@/Components/InputLabel";
import TextInput from "@/Atoms/Input/TextInput/TextInput";
import React, { ChangeEvent } from "react";
import InputError from "@/Components/InputError";
import DatePicker from "@/Atoms/Date/DatePicker";
import PlaceSelect from "@/Atoms/Select/PlaceSelect";
import { PersonFieldsProps } from "@/Organisms/Page/PersonFields";

export default ({data, area, setData, errors, canCreate, isMain}: {
  data: PersonFieldsProps;
  area?: ((name: string) => Record<string, any>) | null;
  setData: (key: string, value: any) => void;
  errors: any;
  canCreate: boolean;
  isMain: boolean;
}) => {
  const getAreaProps = (name: string) => area?.(name) ?? {};

  return <>
    <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4"}>

      <div>
        <InputLabel
          htmlFor="first_name"
          value="Voornaam"
          required
          data-testid={"first_name"}
        />
        <TextInput
          id="first_name"
          name={'first_name'}
          value={data.first_name ?? ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setData("first_name", e.target.value)}
          fullWidth
          {...getAreaProps('first_name')}
        />
        <InputError message={errors.first_name} className="mt-2" />
      </div>

      <div className={"flex gap-2"}>
        <div className={'flex-1'}>
          <InputLabel
            htmlFor="last_name"
            value="Achternaam"
            required

            data-testid={"last_name"}
          />
          <TextInput
            name={'last_name'}
            id="last_name"
            fullWidth
            value={data.last_name ?? ""}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setData("last_name", e.target.value)}
            {...getAreaProps('last_name')}
          />
          <InputError message={errors.last_name} className="mt-2" />
        </div>
        <div className={"flex-0"} style={{minWidth: '106px'}}>
          <InputLabel
            htmlFor="gender"
            value="Geslacht"
            data-testid={"gender"}

          />
          <select
            id="gender"
            data-testid={'gender'}
            value={data.gender}
            onChange={(e: any) => setData("gender", e.target.value)}
          >
            <option value={''}></option>
            <option value={'male'}>Man</option>
            <option value={'female'}>Vrouw</option>
            <option value={'non-binary'}>Non-binair</option>
            {/*<option value={'other'}>Nvt.</option>*/}
          </select>
        </div>

      </div>

      <div>
        <InputLabel
          htmlFor="nickname"
          value="Roepnaam"
          data-testid={"nickname"}
        />
        <TextInput
          id="nickname"
          name={'nickname'}
          fullWidth
          value={data.nickname ?? ""}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setData("nickname", e.target.value)}
          {...getAreaProps('nickname')}
        />
        <InputError message={errors.nickname} className="mt-2" />
      </div>

    </div>

    <div className={"grid grid-cols-1  md:grid-cols-2 lg:grid-cols-2 gap-4"}>
      <div>
        <InputLabel
          htmlFor="birth_date"
          value="Geboortedatum"
          required={isMain}
          data-testid={"birth_date"}
        />
        <DatePicker
          id="birth_date"
          name="birth_date"
          value={data.birth_date ?? ""}
          onChange={(date: any) => setData("birth_date", date)}
          className={"!block"}
          {...getAreaProps('birth_date')}
        />
        <InputError message={errors.birth_date} className="mt-2" />
      </div>
      <div>
        <InputLabel
          htmlFor="birth_place"
          value="Geboorteplaats"
          required={isMain}
          data-testid={"birth_place"}
        />
        <PlaceSelect
          id="birth_place"
          name={'birth_place'}
          value={data.birth_place ?? undefined}
          onChange={(place: any) => setData("birth_place", place)}
          canCreate={canCreate}
          {...getAreaProps('birth_place')}
          className={'w-full'}
        />
        <InputError
          message={errors["birth_place.value"]}
          className="mt-2"
        />
      </div>
      <div>
        <InputLabel
          htmlFor="deceased_date"
          value="Overleden op"
          required={isMain}
          data-testid={"deceased_date"}
        />
        <DatePicker
          id="deceased_date"
          name={"deceased_date"}
          value={data.deceased_date ?? ""}
          onChange={(date: any) => setData("deceased_date", date)}
          className={"!block"}
          {...getAreaProps('deceased_date')}
        />
        <InputError message={errors.deceased_date} className="mt-2" />
      </div>
      <div>
        <InputLabel
          htmlFor="deceased_place"
          value="Overleden te"
          required={isMain}
          data-testid={"deceased_place"}
        />
        <PlaceSelect
          id="deceased_place"
          name={'deceased_place'}
          value={data.deceased_place ?? undefined}
          onChange={(place: any) => setData("deceased_place", place)}
          canCreate={canCreate}
          {...getAreaProps('deceased_place')}
          className={'w-full'}
        />
        <InputError
          message={errors["deceased_place.value"]}
          className="mt-2"
        />
      </div>
    </div>
  </>
}

